import React from "react";
import i18n from "@microdoing/shared/i18n";
import { getComment } from "@microdoing/shared/services/action/selectors";
import { getFilesToUpload } from "@microdoing/shared/services/upload/selectors";
import { Box, MainText, PressableOpacity } from "app/components/common";
import { useSelector } from "react-redux";
import { UploadFilesScrollView } from "../Component/UploadFilesScrollView";
import { useNavigation } from "@react-navigation/native";
import normalize from "app/utils/normalize";
import FastImage from "react-native-fast-image";

const PenImage = require("../../../../../assets/images/Pencil.png");

const ICON_WIDTH = normalize(19);

interface ITextAndImageAnalysis {}

const TextAndImageAnalysis = ({}: ITextAndImageAnalysis) => {
  const comment = useSelector(getComment);
  const filesToUpload = useSelector(getFilesToUpload);

  return (
    <Box flex={1}>
      <Box flexDirection="row" alignItems="center" marginBottom="m">
        <MainText variant="l2-medium" color="neutral.600">
          {i18n.t("recap-feedback-commentary")}
        </MainText>
      </Box>
      <Box
        width="100%"
        borderRadius={normalize(6)}
        marginBottom="xxs"
        backgroundColor="neutral.50"
        padding="sm"
      >
        {!!comment && (
          <MainText variant="l3-medium" numberOfLines={3}>
            {comment}
          </MainText>
        )}
        {comment.length === 0 && !filesToUpload?.length && (
          <MainText variant="l3-medium">
            {i18n.t("recap-feedback-no-commentary")}
          </MainText>
        )}
        {filesToUpload.length > 0 && (
          <Box marginTop={{ phone: "sm", smallWeb: "null", web: "sm" }}>
            <UploadFilesScrollView isValidateRequesting={false} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default TextAndImageAnalysis;
